import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20collage%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%2C%20patterned%20sweaters%2C%20denim%20jackets%2C%20leather%20bags%20and%20accessories%20arranged%20in%20an%20artistic%20scattered%20composition%20on%20a%20soft%20gradient%20pastel%20pink%20to%20mint%20background%2C%20playful%20contemporary%20product%20photography%2C%20bright%20cheerful%20aesthetic%2C%20creative%20editorial%20style%2C%20soft%20diffused%20studio%20lighting%2C%20harmonious%20colorful%20palette%2C%20high%20detail%20professional%20commercial%20presentation&width=1800&height=1200&seq=hero-bg-v2-main-01&orientation=landscape"
          alt="OOPBuy Spreadsheet product collection background"
          title="OOPBuy Spreadsheet product collection"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 pt-24 md:pt-28 flex flex-col items-center text-center">
        <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white/90 text-xs md:text-sm font-medium tracking-wider uppercase mb-6 md:mb-8">
          Verified Product Database
        </span>

        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white tracking-wide leading-tight md:leading-none">
          OOPBUY
          <br />
          SPREADSHEET
        </h1>

        <p className="mt-5 md:mt-6 text-sm md:text-lg text-white/80 font-light max-w-2xl leading-relaxed">
          Your smart bridge to curated sourcing. Jump to kaspreadsheet.com for full catalog access across 14 verified product categories.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mt-8 md:mt-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-950 rounded-full text-sm md:text-base font-semibold hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
          >
            oopbuy spreadsheet
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-3-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="mt-12 md:mt-14 w-full max-w-3xl">
          <p className="text-white/60 text-xs md:text-sm mb-3">Browse categories directly:</p>
          <div className="flex flex-wrap justify-center gap-2">
            {categories.map((cat) => (
              <a
                key={cat.slug}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-3.5 py-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white/85 text-xs md:text-sm hover:bg-white/20 hover:border-white/40 transition-all whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}